export default function HeroDecoration({ src, className }) {
  return <img src={src} alt="Decoration" className={`${className} hero-decoration`} />;
}
